<template>
  <div class="chatMessageContentBox" v-if="messages">
    <template v-for="(chat, index) in messages">
      <div :key="'line-'+index" v-if="messageIsDayOver(index)" class="dateChangeBar">
        &emsp;{{ printDateLine(chat.createDate) }}&emsp;
      </div>
      <div v-if="chat.messageType === 'START'" :key="'start-' + index" class="alertBar">
        受付開始(<b>{{ chat.senderName }}</b>) {{ printDateLine(chat.createDate) }}
      </div>
      <div v-if="chat.messageType === 'CONNECT'" :key="'connect-' + index"
           class="alertBar">
        <span v-html="parseTextFromContent(chat.content)"></span>
      </div>
      <div v-else-if="chat.messageType === 'END' && !isScenario(chat.channelName)" :key="'end-' + index"
           class="alertBar"
           :style="duplicateExitMessage(index) ? 'display: none;' : ''">
        <span v-html="closeMessageSelector(chat.senderType, chat.senderName)">{{ closeMessageSelector(chat.senderType, chat.senderName) }}</span>
        {{ printDateLine(chat.createDate) }}
      </div>
      <div v-else-if="chat.messageType === 'END' && isScenario(chat.channelName)" :key="'end-' + index"
           class="alertBar">
        <span class="botIcon">チャットボット相談が終了しました。</span>
      </div>
      <div v-else-if="chat.messageType === 'TAKE_OVER'" :key="'take-' + index"
           class="alertBar">
        <span v-html="parseTextFromContent(chat.content, chat.messageType)"></span>
      </div>
<!--      <div v-if="chat.messageType === 'BROWSER_EXIT'" :key="'browser-exit-' + index"-->
<!--           class="alertBar">-->
<!--        <span v-html="parseTextFromContent(chat.content)"></span>-->
<!--      </div>-->
      <div v-if="chat.messageType === 'AUTO_CLOSE'" :key="'auto-close-' + index" class="alertBar">
        <span v-html="parseTextFromContent(chat.content)"></span>
      </div>
      <mail-messages v-if="channelName === 'MAIL'" :key="index" :chat="chat" :channelName="channelName" :userName="userName" :iconUrl="iconUrl"></mail-messages>
      <chat-messages v-else :key="index" :chat="chat" :channelName="channelName" :userName="userName" :status="status"
                     :ban-words="banWords" :set-ban-words-count="setBanWordsCount" :is-last-index="messages.length - 1 === index"
                     :isScenario="isScenario"
                     :iconUrl="iconUrl"></chat-messages>
    </template>
  </div>
</template>

<script>
import helper from 'util/helpers'
import chatMessages from './chat_messages'
import mailMessages from './mail_messages'

export default {
  name: 'chat_message_content',
  components: {
    chatMessages,
    mailMessages
  },
  props: {
    messages: Array,
    banWords: Array,
    setBanWordsCount: Function,
    status: String,
    userName: String,
    channelName: String,
    iconUrl: String
  },
  methods: {
    isScenario (channelName) {
      return channelName === 'SCENARIO'
    },
    closeMessageSelector (senderType, senderName) {
      if (senderType === 'AGENT') {
        return '相談終了 (<b>' + senderName + '</b>)'
      }
      return '相談終了 (顧客)'
    },
    messageIsDayOver (index) {
      if (this.messages.length === 0 || index === 0) {
        return false
      }

      const currentDate = helper.getDateTimeObject(this.messages[index].createDate)
      const beforeDate = helper.getDateTimeObject(this.messages[index - 1].createDate)
      return currentDate.date() !== beforeDate.date()
    },
    parseTextFromContent (content, messageType) {
      if (messageType === 'HIDE_MESSAGE') {
        return
      }
      const jsonContent = JSON.parse(content)
      return jsonContent.text
    },
    printDateLine (datetimeString) {
      return helper.printDateFromDateTime(datetimeString)
    },
    duplicateExitMessage (index) {
      return index > 0 && this.messages[index - 1].content === this.messages[index].content
    }
  }
}
</script>

<style lang="scss">
  .chatMessageContentBox {
    background-color: #eff0f0;
    padding: 0 10px 30px 10px;
    display: flow-root;
    .dateChangeBar {
      margin-top: 30px;
      position: relative;
      text-align: center;
      font-size: 12px;
      color: $gray-7;
      &:before, &:after {
        content: '';
        width: calc(50% - 55px);
        height: 1px;
        position: absolute;
        top: 8px;
        background-color: $gray-4;
      }
      &:before {
        left: 0;
      }
      &:after {
        right: 0;
      }
    }
    .alertBar {
      background-color: $gray-4;
      border-radius: 5px;
      color: #000000;
      @include font-style(14px, 400, 20px);
      text-align: center;
      padding: 5px 0 5px 0;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 30px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/operation/fragments/chat_area/chat_message_content.vue